import { postBodySignatureQueryFunction } from '@/modules/adjusterReportModules/queries/postSignature/postBodySignatureQueryFunction';
import { postInitialVisitSignatureQueryFunction } from '@/modules/adjusterReportModules/queries/postSignature/postInitialVisitSignatureQueryFunction';
import { postPropertyCulpritSignatureQueryFunction } from '@/modules/adjusterReportModules/queries/postSignature/postPropertyCulpritSignatureQueryFunction';
import { postPropertyDamagedSignatureQueryFunction } from '@/modules/adjusterReportModules/queries/postSignature/postPropertyDamagedSignatureQueryFunction';
import {
  FileEnType,
  SignatureQueryParamsType,
} from '@/modules/adjusterReportModules/types/signatureQueryParams.type';

export const postSignatureQueryOptions = (type: FileEnType) => {
  const QueryFn = (params: SignatureQueryParamsType) => {
    if (params && type === 'Initial') {
      return postInitialVisitSignatureQueryFunction(params);
    } else if (params && type === 'PropertyCulprit') {
      return postPropertyCulpritSignatureQueryFunction(params);
    } else if (params && type === 'PropertyDamaged') {
      return postPropertyDamagedSignatureQueryFunction(params);
    }
    return postBodySignatureQueryFunction(params);
  };
  return {
    mutationKey: ['postDamagedAdjusterDocumentImages'],
    mutationFn: (params: SignatureQueryParamsType) => QueryFn(params),
  };
};
